// Convert non-numeric values to false, otherwise convert to int/float.
const getNumber = (val, isFloat = false) => {
	if ( null === val || false === val || isNaN(val) ) {
		return false
	}

	val = isFloat ? parseFloat(val) : parseInt(val, 10)

	return ! isNaN(val) ? val : false;
}

// Return a number with commas.
const withCommas = number => {
	return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0'
}

// Change duration depending on the difference between the two numbers.
const getDuration = (from, to) => {
	let duration     = 500
	const difference = to - from

	if (100 < difference) {
		duration = 1000
	} else if (1000 < difference) {
		duration = 2000
	}

	return duration
}

// Get the percentage difference between two numbers.
const difference = (first, second) => {
	return (((first - second) / second) * 100).toFixed(2)
}

export {
	getNumber,
	difference,
	getDuration,
	withCommas
}